import "./Styling/ExpenseItem.css";
import ExpenseDate from "./ExpenseDate";

function ExpenseItem(props) {
  //Main Card for expenses
  return (
    <div className="expense-item">
      <div className="expense-item__description">{props.title}</div>
      <div className="expense-item__MainBody">{props.desc}</div>

      <div className="expense-item__Account">
        {props.account}
        </div>
        <div>
          <ExpenseDate date={props.date} />
        </div>
      
    </div>
  );
}

export default ExpenseItem;
